/**
 * @description Enum for static roles defined in keycloak.
 */
export enum StaticRole {
    LOGIN = 'login'
}
